var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "ci-user-profile-empty-state ci-card ci-section ci-content-padding text-center",
    },
    [
      _c(
        "div",
        { staticClass: "mb-3" },
        [_c("inline-svg", { attrs: { src: _vm.emptyStateIcon } })],
        1
      ),
      _c("h3", {
        staticClass: "h5 mb-4",
        domProps: {
          textContent: _vm._s(
            _vm.$t("ui.components.users.profile.empty_state.title")
          ),
        },
      }),
      _c("p", {
        staticClass: "mb-4",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("ui.components.users.profile.empty_state.empty_state")
          ),
        },
      }),
      _c(
        "div",
        { staticClass: "row flex-center" },
        [
          _c("ci-button", {
            attrs: {
              label: _vm.$t("ui.components.users.profile.empty_state.action"),
              to: {
                name: _vm.$routes.CONTENTS_SHOW,
                params: {
                  slug: "vorteile-der-verifizierung-30-sekunden-tool-tipp",
                },
              },
              variant: "filled-primary",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }